import { parseISODate } from '@/common/application/utils/timeUtils';
import { isValid } from 'date-fns';
import { useQueryState, parseAsBoolean, parseAsIsoDate } from 'nuqs';

export const DEFAULT_PARAMS = {
  module: 'raptorjob',
  tabParam: 'anchor'
};

interface UseRaptorJobQueryReturn {
  // Date parameter state and setter
  date: Date | null;
  setDate: (date: Date | null) => void;

  // Highlight parameter state and setter
  highlight: boolean;
  setHighlight: (highlight: boolean) => void;
}

export const useRaptorJobQuery = (): UseRaptorJobQueryReturn => {
  const [date, setDate] = useQueryState('date', {
    ...parseAsIsoDate,
    parse(value) {
      if (!value) return null;
      const parsed = parseISODate(value);
      return parsed && isValid(parsed) ? parsed : null;
    }
  });

  const [highlight, setHighlight] = useQueryState('highlight', {
    ...parseAsBoolean,
    defaultValue: false
  });

  return {
    date,
    setDate,
    highlight,
    setHighlight
  };
};
